<template>
  <div class="Login-element-input LoginPassword">
    <BSCInput
      :value="login_data.password"
      :message="$t('utils.label.password')"
      @input="inputPassword"
      :placeholder="$t('login.password.placeholder')"
      typeInput="password"
      type="primary"
    />
  </div>
</template>

<script>
'use strict'
import { mapGetters } from 'vuex'

export default {
  name: 'LoginPassword',
  computed: { ...mapGetters({ login_data: 'auth/login_data' }) },
  methods: {
    inputPassword(newValue) {
      this.$store.dispatch('auth/changeUserPassword', newValue)
    }
  }
}
</script>

<style lang="scss">
.LoginPassword {
  margin-top: 16px;

  width: 100%;

  box-sizing: border-box;
}
</style>
